<template>
  <div>
    <div class="emd-panel__section">
      <div class="emd-panel__block">
        <div class="el-chunk">
          <h2 class="emd-text _color_default _type_caption">
            {{ $t('title') }}
          </h2>
        </div>
      </div>
      <div class="emd-panel__block">
        <div class="emd-form-group">
          <label class="emd-label">
            {{ $t('status') }}
          </label>
          <label class="emd-label">
            <jade-tag
              class="eu-mt_2"
              :variant="kycStatus.color"
              size="medium"
            >
              {{ $t(`status-reason.${kycStatus.status}`) }}
            </jade-tag>
            <emd-tippy
              class="eu-ml_2"
              type="simple"
              position="right"
              :content="$t(`status-reason-description.${status}`)"
            >
              <i class="uil uil-info-circle"></i>
            </emd-tippy>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import JadeTag from '@jade/JadeTag/index.vue'
import { EmdTippy } from 'emerald-vue/src/components'

import { KYC_STATUS_REASON_ENUM, KYC_STATUS_ENUM } from '@/enums/kyc.enum'

const KYC_STATUS_REASON_MESSAGES_ENUM = {
  [KYC_STATUS_REASON_ENUM.WAITING_ANALYSIS]: {
    status: KYC_STATUS_ENUM.PENDING,
    color: 'warning'
  },
  [KYC_STATUS_REASON_ENUM.IN_ANALYSIS]: {
    status: KYC_STATUS_ENUM.PENDING,
    color: 'warning'
  },
  [KYC_STATUS_REASON_ENUM.ADDITIONAL_DOCUMENTS_REQUIRED]: {
    status: KYC_STATUS_ENUM.PARTIALLY_DENIED,
    color: 'warning'
  },
  [KYC_STATUS_REASON_ENUM.OK]: {
    status: KYC_STATUS_ENUM.APPROVED,
    color: 'positive'
  },
  [KYC_STATUS_REASON_ENUM.REJECTED_BY_RISK]: {
    status: KYC_STATUS_ENUM.DENIED,
    color: 'negative'
  },
  [KYC_STATUS_REASON_ENUM.FULLY_DENIED]: {
    status: KYC_STATUS_ENUM.DENIED,
    color: 'negative'
  }
}

export default {
  name: 'BiometryKyc',
  components: {
    JadeTag,
    EmdTippy
  },
  props: {
    status: {
      type: String,
      validation: status =>
        Object.values(KYC_STATUS_REASON_ENUM).includes(status),
      required: true
    }
  },
  computed: {
    kycStatus () {
      return KYC_STATUS_REASON_MESSAGES_ENUM[this.status]
    }
  }
}
</script>
<i18n>
    {
      "pt-BR": {
        "title": "Biometria (KYC)",
        "status": "Status",
        "status-reason": {
          "pending": "Pendente",
          "partially_denied": "Parcialmente negado",
          "approved": "Aprovado",
          "denied": "Negado"
        },
        "status-reason-description": {
          "waiting_analysis": "A biometria foi iniciada e está esperando análise.",
          "in_analysis": "A biometria está em análise.",
          "additional_documents_required": "A biometria possui pendências e será necessário responde-las.",
          "ok": "A biometria foi finalizada e a conta de pagamento foi criada.",
          "rejected_by_risk": "A biometria foi negada.",
          "fully_denied": "A biometria foi negada."
        }
      },
      "en-US": {
        "title": "Biometrics (KYC)",
        "status": "Status",
        "status-reason": {
          "pending": "Pending",
          "partially_denied": "Partially denied",
          "approved": "Approved",
          "denied": "Denied"
        },
        "status-reason-description": {
          "waiting_analysis": "Biometrics has been started and is awaiting analysis.",
          "in_analysis": "Biometrics is under analysis.",
          "additional_documents_required": "Biometrics has pending issues and will need to be answered.",
          "ok": "Biometrics has been completed and payment account has been created.",
          "rejected_by_risk": "Biometrics was denied.",
          "fully_denied": "Biometrics was denied."
        }
      }
    }
    </i18n>
